export default "__VITE_ASSET__Vd8OMcUT__"